var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
var _hoisted_1 = { class: "text-lg" };
var _hoisted_2 = { class: "text-sm mt-0.5" };
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "relative top-[-1px] text-lg" }, " + ", -1);
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "relative top-[-1px] text-lg" }, " — ", -1);
var _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "w-px h-6 bg-gray-500 bg-opacity-30 mx-1" }, null, -1);
var _hoisted_9 = { class: "text-dark" };
import { computed, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import EPdfViewer from '@common/ui/EPdfViewer/EPdfViewer.vue';
import EIcon from '@common/ui/EIcon.vue';
import EButton from '@common/ui/EButton.vue';
import { convertWebpToJpeg, downloadFileByURL } from '@common/utils/File/File';
var minSize = 10;
var maxSize = 500;
var sizeStep = 10;
export default /*#__PURE__*/ _defineComponent({
    __name: 'showFile',
    props: {
        fileData: {},
        isFileOpen: { type: Boolean }
    },
    emits: ["update:isFileOpen", "close"],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var currentSize = ref(100);
        var sizeHistory = ref([100]);
        var currentHistoryIndex = ref(0);
        var plusSizeLevel = computed(function () { return currentSize.value < maxSize; });
        var minusSizeLevel = computed(function () { return currentSize.value > minSize; });
        var addToHistory = function (size) {
            sizeHistory.value = sizeHistory.value.slice(0, currentHistoryIndex.value + 1);
            sizeHistory.value.push(size);
            currentHistoryIndex.value = sizeHistory.value.length - 1;
        };
        var toPlusSize = function () {
            if (plusSizeLevel.value) {
                var newSize = currentSize.value + sizeStep;
                currentSize.value = newSize;
                addToHistory(newSize);
            }
        };
        var toMinusSize = function () {
            if (minusSizeLevel.value) {
                var newSize = currentSize.value - sizeStep;
                currentSize.value = newSize;
                addToHistory(newSize);
            }
        };
        var resetSize = function () {
            currentSize.value = 100;
            addToHistory(100);
        };
        var currentRotation = ref(0);
        var rotateLeft = function () {
            currentRotation.value -= 90;
        };
        var rotateRight = function () {
            currentRotation.value += 90;
        };
        var imageStyle = computed(function () { return ({
            transform: "scale(".concat(currentSize.value / 100, ") rotate(").concat(currentRotation.value, "deg)"),
            transition: 'transform 0.2s ease'
        }); });
        var closePreview = function () {
            currentSize.value = 100;
            currentRotation.value = 0;
            sizeHistory.value = [100];
            currentHistoryIndex.value = 0;
            emit('update:isFileOpen', false);
            emit('close');
        };
        var downloadFile = function () { return __awaiter(_this, void 0, void 0, function () {
            var fileName, fileUrl, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        fileName = (_a = props.fileData) === null || _a === void 0 ? void 0 : _a.name;
                        fileUrl = (_b = props.fileData) === null || _b === void 0 ? void 0 : _b.url;
                        if (!fileName || !fileUrl)
                            return [2 /*return*/];
                        if (!fileName.toLowerCase().endsWith('.webp')) return [3 /*break*/, 5];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, convertWebpToJpeg(fileUrl, fileName)];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        console.error('Ошибка при конвертации webp → jpeg', err_1);
                        downloadFileByURL(fileUrl, fileName);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        downloadFileByURL(fileUrl, fileName);
                        _c.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        var isControlsVisible = ref(true);
        var hideControlsTimeout = null;
        var showControls = function () {
            isControlsVisible.value = true;
            if (hideControlsTimeout) {
                clearTimeout(hideControlsTimeout);
            }
            hideControlsTimeout = setTimeout(function () {
                isControlsVisible.value = false;
            }, 4000);
        };
        var onMouseMove = function () {
            showControls();
        };
        onMounted(function () {
            showControls();
        });
        return function (_ctx, _cache) {
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                visible: _ctx.isFileOpen,
                background: "none",
                name: "show-file",
                size: "full",
                "append-to-body": "",
                "custom-overlay": "",
                "no-padding": "",
                onClose: closePreview,
                onMousemove: onMouseMove
            }, {
                overlay: _withCtx(function () { return [
                    _createElementVNode("div", {
                        class: _normalizeClass([[
                                isControlsVisible.value ? 'opacity-100' : 'opacity-0'
                            ], "absolute top-7 w-full text-white z-10 flex items-end justify-end px-6"]),
                        onClick: closePreview
                    }, [
                        _createVNode(EButton, {
                            class: "w-8 h-8 bg-black bg-opacity-70 rounded-lg flex items-center justify-center hover:bg-opacity-50 transition-colors",
                            size: "nosize",
                            type: "text",
                            onClick: _withModifiers(closePreview, ["stop"])
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(EIcon, {
                                    class: "w-4 h-4",
                                    icon: "close"
                                })
                            ]; }),
                            _: 1
                        })
                    ], 2)
                ]; }),
                default: _withCtx(function () {
                    var _a, _b, _c, _d, _e, _f, _g;
                    return [
                        _createElementVNode("div", {
                            class: "w-full text-white z-10 flex justify-between items-center px-6 h-[88px] bg-black/70",
                            onClick: closePreview
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass([[
                                        isControlsVisible.value ? 'opacity-100' : 'opacity-0'
                                    ], "flex flex-col"])
                            }, [
                                _createElementVNode("div", _hoisted_1, _toDisplayString((_a = props.fileData) === null || _a === void 0 ? void 0 : _a.name), 1),
                                _createElementVNode("div", _hoisted_2, _toDisplayString((_b = props.fileData) === null || _b === void 0 ? void 0 : _b.size), 1)
                            ], 2)
                        ]),
                        _createElementVNode("div", {
                            class: "w-full flex items-center justify-center bg-black/70",
                            style: { "height": "calc(100vh - 176px)" },
                            onClick: closePreview
                        }, [
                            (((_c = props.fileData) === null || _c === void 0 ? void 0 : _c.type) === 'video')
                                ? (_openBlock(), _createElementBlock("video", {
                                    key: 0,
                                    src: props.fileData.url,
                                    class: "h-full max-w-full min-w-[70vw] rounded-lg w-auto",
                                    autoplay: "",
                                    controls: "",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(function () { }, ["stop"]))
                                }, _toDisplayString(_unref(t)('fileUpload.browserNotSupport')), 9, _hoisted_3))
                                : (((_d = props.fileData) === null || _d === void 0 ? void 0 : _d.type) === 'image')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: props.fileData.url,
                                        style: _normalizeStyle(imageStyle.value),
                                        alt: "",
                                        class: "max-w-full max-h-full object-contain cursor-move rounded-lg",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(function () { }, ["stop"])),
                                        onDblclick: resetSize
                                    }, null, 44, _hoisted_4))
                                    : (((_e = props.fileData) === null || _e === void 0 ? void 0 : _e.type) === 'pdf')
                                        ? (_openBlock(), _createBlock(EPdfViewer, {
                                            key: 2,
                                            "fit-by-height": true,
                                            src: props.fileData.url,
                                            class: "h-full rounded-lg max-w-[80vw] min-w-[40vw]",
                                            onClick: _cache[2] || (_cache[2] = _withModifiers(function () { }, ["stop"]))
                                        }, null, 8, ["src"]))
                                        : (((_f = props.fileData) === null || _f === void 0 ? void 0 : _f.type) === 'office')
                                            ? (_openBlock(), _createElementBlock("iframe", {
                                                key: 3,
                                                src: "https://view.officeapps.live.com/op/embed.aspx?src=".concat(props.fileData.url, "&embedded=true"),
                                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; microphone *; payment; camera *; encrypted-media; display-capture *",
                                                allowtransparency: "true",
                                                class: "h-full max-w-full min-w-[70vw] rounded-lg w-auto",
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(function () { }, ["stop"]))
                                            }, null, 8, _hoisted_5))
                                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", {
                            class: "h-[88px] w-full absolute bottom-0 py-6 flex justify-center items-center bg-black/70",
                            onClick: closePreview
                        }, [
                            (((_g = props.fileData) === null || _g === void 0 ? void 0 : _g.type) === 'image')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass([[
                                            isControlsVisible.value ? 'opacity-100' : 'opacity-0'
                                        ], "flex items-center gap-2 bg-gray-800 rounded-lg p-1 text-white"]),
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(function () { }, ["stop"]))
                                }, [
                                    _createVNode(EButton, {
                                        class: _normalizeClass([[
                                                !plusSizeLevel.value && 'text-opacity-30'
                                            ], "h-8 w-8 rounded-md bg-gray-500 bg-opacity-30 hover:bg-opacity-50 transition-colors"]),
                                        disabled: !plusSizeLevel.value,
                                        size: "nosize",
                                        type: "text",
                                        onClick: toPlusSize
                                    }, {
                                        default: _withCtx(function () { return [
                                            _hoisted_6
                                        ]; }),
                                        _: 1
                                    }, 8, ["class", "disabled"]),
                                    _createElementVNode("button", {
                                        class: "text-lg hover:text-gray-300 transition-colors cursor-pointer",
                                        onClick: resetSize
                                    }, _toDisplayString(currentSize.value) + " % ", 1),
                                    _createVNode(EButton, {
                                        class: _normalizeClass([[
                                                !minusSizeLevel.value && 'text-opacity-30'
                                            ], "h-8 w-8 rounded-md hover:bg-gray-500 bg-gray-500 bg-opacity-30 hover:bg-opacity-50 transition-colors"]),
                                        disabled: !minusSizeLevel.value,
                                        size: "nosize",
                                        type: "text",
                                        onClick: toMinusSize
                                    }, {
                                        default: _withCtx(function () { return [
                                            _hoisted_7
                                        ]; }),
                                        _: 1
                                    }, 8, ["class", "disabled"]),
                                    _hoisted_8,
                                    _createVNode(EButton, {
                                        class: "h-8 w-8 rounded-md hover:bg-opacity-50 hover:bg-gray-500 transition-colors",
                                        size: "nosize",
                                        type: "text",
                                        onClick: rotateLeft
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(EIcon, {
                                                class: "w-4 h-4",
                                                icon: "arrow-left-round-2"
                                            })
                                        ]; }),
                                        _: 1
                                    }),
                                    _createVNode(EButton, {
                                        class: "h-8 w-8 rounded-md hover:bg-opacity-50 hover:bg-gray-500 transition-colors",
                                        size: "nosize",
                                        type: "text",
                                        onClick: rotateRight
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(EIcon, {
                                                class: "w-4 h-4",
                                                icon: "arrow-right-round-2"
                                            })
                                        ]; }),
                                        _: 1
                                    }),
                                    _createVNode(EButton, {
                                        class: "h-8 w-8 rounded-md",
                                        size: "nosize",
                                        type: "primary",
                                        onClick: _withModifiers(downloadFile, ["stop"])
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(EIcon, {
                                                class: "w-4 h-4",
                                                icon: "download"
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ], 2))
                                : (_openBlock(), _createBlock(EButton, {
                                    key: 1,
                                    class: _normalizeClass([[
                                            isControlsVisible.value ? 'opacity-100' : 'opacity-0'
                                        ], "flex items-center justify-center z-10"]),
                                    type: "white",
                                    onClick: _withModifiers(downloadFile, ["stop"])
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(EIcon, {
                                            class: "h-4 w-4 mr-2.5 text-dark",
                                            icon: "download"
                                        }),
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('fileUpload.download')), 1)
                                    ]; }),
                                    _: 1
                                }, 8, ["class"]))
                        ])
                    ];
                }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
